import { FC, useMemo } from "react";

import Box from "@mui/material/Box";
import Button, { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import MaximizeIcon from "../icons/MaximizeIcon";

interface ExtendButtonProps extends ButtonProps {
  changeExpandedMode: () => void;
  title: string;
  hideStartIcon?: boolean;
}

const ExtendButton: FC<ExtendButtonProps> = ({
  changeExpandedMode,
  title,
  hideStartIcon,
  variant,
}) => {
  const memoizedButtonStyles = useMemo(
    () =>
      !variant
        ? {
            zIndex: 10,
            "&, &:hover": {
              color: "primary.main",
              border: "1px solid",
              borderColor: "primary.main",
              backgroundColor: "otherBackgroundLight.main",
              textTransform: "none",
            },
          }
        : {},
    [variant]
  );

  return (
    <Box
      sx={{
        position: "absolute",
        right: 6,
        top: 6,
      }}
    >
      <Button
        sx={memoizedButtonStyles}
        startIcon={hideStartIcon ? null : <MaximizeIcon />}
        variant={variant}
        size="small"
        onClick={changeExpandedMode}
      >
        <Typography variant="buttonMedium" component="span">
          {title}
        </Typography>
      </Button>
    </Box>
  );
};

export default ExtendButton;
